// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import merge from "lodash.merge";

import en_about from "./i18n/en/about.json";
import en_applications from "./i18n/en/applications.json";
import en_cases from "./i18n/en/cases.json";
import en_clients from "./i18n/en/clients.json";
import en_consent from "./i18n/en/consent.json";
import en_contact from "./i18n/en/contact.json";
import en_contact_btn from "./i18n/en/contact_btn.json";
import en_contact_cta from "./i18n/en/contact_cta.json";
import en_footer from "./i18n/en/footer.json";
import en_hero from "./i18n/en/hero.json";
import en_legal from "./i18n/en/legal.json";
import en_nav from "./i18n/en/nav.json";
import en_logos_heading from "./i18n/en/logos_heading.json";
import en_notFound from "./i18n/en/notFound.json";
import en_process from "./i18n/en/process.json";
import en_projects from "./i18n/en/projects.json";
import en_reviews from "./i18n/en/reviews.json";
import en_services from "./i18n/en/services.json";
import en_team from "./i18n/en/team.json";

import ro_about from "./i18n/ro/about.json";
import ro_applications from "./i18n/ro/applications.json";
import ro_cases from "./i18n/ro/cases.json";
import ro_clients from "./i18n/ro/clients.json";
import ro_consent from "./i18n/ro/consent.json";
import ro_contact from "./i18n/ro/contact.json";
import ro_contact_btn from "./i18n/ro/contact_btn.json";
import ro_contact_cta from "./i18n/ro/contact_cta.json";
import ro_footer from "./i18n/ro/footer.json";
import ro_hero from "./i18n/ro/hero.json";
import ro_legal from "./i18n/ro/legal.json";
import ro_nav from "./i18n/ro/nav.json";
import ro_logos_heading from "./i18n/ro/logos_heading.json";
import ro_notFound from "./i18n/ro/notFound.json";
import ro_process from "./i18n/ro/process.json";
import ro_projects from "./i18n/ro/projects.json";
import ro_reviews from "./i18n/ro/reviews.json";
import ro_services from "./i18n/ro/services.json";
import ro_team from "./i18n/ro/team.json";

const enCommon = merge(
  {},
  en_about,
  en_applications,
  en_cases,
  en_clients,
  en_consent,
  en_contact,
  en_contact_btn,
  en_contact_cta,
  en_footer,
  en_hero,
  en_legal,
  en_nav,
  en_logos_heading,
  en_notFound,
  en_process,
  en_projects,
  en_reviews,
  en_services,
  en_team
);

const roCommon = merge(
  {},
  ro_about,
  ro_applications,
  ro_cases,
  ro_clients,
  ro_consent,
  ro_contact,
  ro_contact_btn,
  ro_contact_cta,
  ro_footer,
  ro_hero,
  ro_legal,
  ro_nav,
  ro_logos_heading,
  ro_notFound,
  ro_process,
  ro_projects,
  ro_reviews,
  ro_services,
  ro_team
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon },
      ro: { common: roCommon },
    },
    fallbackLng: "en",
    ns: ["common"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      lookupQuerystring: "lang",
      caches: ["localStorage"],
    },
  });

i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") document.documentElement.lang = lng;
});

export default i18n;
